export default {
    namespaced: true,
    state: {
        user: {}
    },
    mutations: {
        setuser(state, user) {
            state.user = user;
        },
        clearuser(state) {
            state.user = {};
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/account.js